module.exports = __webpack_public_path__ + "static/media/icon_kei3970a9f993183ad960669483ef794f35.webp";